import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import BASE_URL from "../../../config/config";
import { Snackbar, Alert } from "@mui/material";
const BlogCreate = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    alt: "",
    title: "",
    subtitle: "",
    description: "",
    author: "",
    about: "",
    date: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editBlogId, setEditBlogId] = useState(null);
  const [listingHeading, setListingHeading] = useState("");
  const [listingContent, setListingContent] = useState("");
  const [listings, setListings] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const entriesPerPage = 2;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const addListing = () => {
    if (listingHeading.trim() && listingContent.trim()) {
      setListings([
        ...listings,
        { heading: listingHeading, content: listingContent },
      ]);
      setListingHeading("");
      setListingContent("");
    }
  };

  const deleteListing = (index) => {
    setListings(listings.filter((_, i) => i !== index));
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error"

  const handleSnackbarClose = () => setSnackbarOpen(false);

  // const handleSubmit = async () => {
  //   const token = localStorage.getItem("token");
  //   const form = new FormData();
  //   for (const key in formData) form.append(key, formData[key]);
  //   if (image) form.append("image", image);
  //   form.append("listings", JSON.stringify(listings));

  //   const url = isEditing
  //     ? `${BASE_URL}/blogs/${editBlogId}`
  //     : `${BASE_URL}/blogs`;
  //   const method = isEditing ? "PUT" : "POST";

  //   try {
  //     const response = await fetch(url, {
  //       method,
  //       headers: { Authorization: `Bearer ${token}` },
  //       body: form,
  //     });

  //     if (!response.ok) throw new Error("Failed to submit blog");

  //     await response.json();
  //     resetForm();
  //     fetchBlogs();

  //     setSnackbarMessage("Blog saved successfully!");
  //     setSnackbarSeverity("success");
  //     setSnackbarOpen(true);
  //   } catch (error) {
  //     console.error("Error submitting blog:", error);
  //     setSnackbarMessage("Error submitting blog");
  //     setSnackbarSeverity("error");
  //     setSnackbarOpen(true);
  //   }
  // };
  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    const form = new FormData();

    for (const key in formData) form.append(key, formData[key]);
    if (image) form.append("image", image);
    form.append("listings", JSON.stringify(listings));

    const url = isEditing
      ? `${BASE_URL}/blogs/${editBlogId}`
      : `${BASE_URL}/blogs`;

    const method = isEditing ? "PATCH" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });

      const data = await response.json();

      if (!response.ok)
        throw new Error(data.message || "Failed to submit blog");

      resetForm();
      fetchBlogs();

      setSnackbarMessage(
        isEditing ? "Blog updated successfully!" : "Blog saved successfully!"
      );
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error submitting blog:", error);
      setSnackbarMessage("Error submitting blog");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  // edit data
  const handleEdit = (blog) => {
    console.log("Blog being edited----------------:", blog);
    setFormData({
      alt: blog.alt || "",
      title: blog.title || "",
      subtitle: blog.subtitle || "",
      description: blog.description || "",
      author: blog.author || "",
      about: blog.about || "",
      date: blog.date?.split("T")[0] || "",
    });
    setListings(blog.listings || []);
    setImage(null);
    setPreview(
      blog.image?.includes("http")
        ? blog.image
        : `${BASE_URL}/employees/view/${blog.image}`
    );
    setIsEditing(true);
    setEditBlogId(blog.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  // delete data
  // const handleApiDelete = async (id, indexOnCurrentPage) => {
  //   const token = localStorage.getItem("token");
  //   const actualIndex = (currentPage - 1) * entriesPerPage + indexOnCurrentPage;

  //   try {
  //     const res = await fetch(`${BASE_URL}/blogs/${id}`, {
  //       method: "DELETE",
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     if (!res.ok) throw new Error("Failed to delete blog");
  //     setBlogs(blogs.filter((_, i) => i !== actualIndex));
  //   } catch (err) {
  //     console.error("Error deleting blog:", err);
  //   }
  // };
  const handleApiDelete = async (id, indexOnCurrentPage) => {
    const token = localStorage.getItem("token");
    const actualIndex = (currentPage - 1) * entriesPerPage + indexOnCurrentPage;

    try {
      const res = await fetch(`${BASE_URL}/blogs/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Failed to delete blog");

      setBlogs(blogs.filter((_, i) => i !== actualIndex));
      setSnackbarMessage("Blog deleted successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error deleting blog:", err);
      setSnackbarMessage("Failed to delete blog.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  // get data
  const fetchBlogs = () => {
    fetch(`${BASE_URL}/blogs/list`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setBlogs(data.data || []);
        else console.error("Fetch failed:", data.message);
      })
      .catch((err) => console.error("API error:", err));
  };

  const resetForm = () => {
    setFormData({
      alt: "",
      title: "",
      subtitle: "",
      description: "",
      author: "",
      about: "",
      date: "",
    });
    setListings([]);
    setImage(null);
    setPreview(null);
    setIsEditing(false);
    setEditBlogId(null);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["blockquote"],
      ["link", "image"],
    ],
  };
  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "bullet",
    "indent",
    "align",
    "blockquote",
    "link",
    "image",
  ];
  return (
    <div className="w-full mx-auto p-6 bg-white rounded shadow space-y-6">
      <h1 className="text-3xl font-bold text-center mb-6">Create Blog</h1>

      {/* Upload and Alt */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-base font-medium mb-1">
            Upload Image *
          </label>
          <input type="file" onChange={handleImageChange} />
          {preview && (
            <img
              src={preview}
              alt="preview"
              className="mt-2 w-28 h-28 object-contain rounded"
            />
          )}
        </div>
        <div>
          <label className="block text-base font-medium mb-1">Alt Text *</label>
          <input
            type="text"
            name="alt"
            value={formData.alt}
            onChange={handleChange}
            className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-base font-medium mb-1">Title *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
        <div>
          <label className="block text-base font-medium mb-1">Author *</label>
          <input
            type="text"
            name="author"
            value={formData.author}
            onChange={handleChange}
            className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
        <div>
          <label className="block text-base font-medium mb-1">About *</label>
          <input
            type="text"
            name="about"
            value={formData.about}
            onChange={handleChange}
            className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
        <div>
          <label className="block text-base font-medium mb-1">Date *</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
          />
        </div>
      </div>

      <div>
        <label className="block text-base font-medium mb-1">Subtitle *</label>
        <input
          name="subtitle"
          value={formData.subtitle}
          onChange={handleChange}
          className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
        />
      </div>

      <div>
        <label className="block text-base font-medium mb-1">
          Description *
        </label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full p-2 mb-1 h-20 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
        />
      </div>
      {/* data listing */}
      <div className="mt-10 px-2 bg-gray-100 py-2 h-86 overflow-x-scroll">
        <h2 className="text-xl font-semibold mb-2">Add Listing </h2>

        <label className="block mb-1">Listing Heading *</label>
        <input
          type="text"
          value={listingHeading}
          onChange={(e) => setListingHeading(e.target.value)}
          className="w-full p-2 mb-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-main1 focus:border-main1 transition duration-200"
        />

        <label className="block mb-1">Listing Content</label>
        <ReactQuill
          value={listingContent}
          onChange={setListingContent}
          className="mb-4"
          modules={quillModules}
          formats={quillFormats}
        />

        <button
          onClick={addListing}
          className="bg-main1  text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Add List
        </button>

        {listings.length > 0 && (
          <div className="mt-6 overflow-x-auto">
            <table className="min-w-full text-center border border-gray-300">
              <thead className="bg-gray-100 ">
                <tr>
                  <th className="border    px-4 py-2">Heading</th>
                  <th className="border px-4 py-2">Content</th>
                  <th className="border px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {listings.map((item, idx) => (
                  <tr key={idx} className="bg-white">
                    <td className="border px-4 py-2 font-medium">
                      {item.heading}
                    </td>
                    <td className="border px-4 py-2">
                      <div
                        className="prose max-w-none"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    </td>
                    <td className="border px-4 py-2">
                      <button
                        onClick={() => deleteListing(idx)}
                        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="w-full bg-gray-800 text-white py-3 rounded text-md hover:bg-gray-700"
      >
        {isEditing ? "Update Blog" : "Final Save"}
      </button>

      {/* Saved Entries Table */}

      {blogs.length > 0 && (
        <div className="mt-10 overflow-x-auto">
          <h2 className="text-xl font-semibold mb-4">All Saved Blogs</h2>

          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-2">Image</th>
                <th className="border border-gray-300 p-2">Title</th>
                <th className="border border-gray-300 p-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {blogs
                .slice(
                  (currentPage - 1) * entriesPerPage,
                  currentPage * entriesPerPage
                )
                .map((entry, index) => (
                  <tr key={index} className="text-center">
                    <td className="border border-gray-300 p-2">
                      {entry.image && (
                        <img
                          src={
                            entry.image.includes("http")
                              ? entry.image
                              : `${BASE_URL}/employees/view/${entry.imageName}`
                          }
                          alt={entry.alt || "blog image"}
                          className="w-20 h-20 object-cover"
                        />
                      )}
                    </td>
                    <td className="border border-gray-300 p-2">
                      {entry.title}
                    </td>
                    <td className="border border-gray-300 p-2 space-x-2">
                      <button
                        onClick={() => handleEdit(entry)}
                        className="bg-blue-500 text-white px-2 py-1 rounded"
                      >
                        <FontAwesomeIcon icon={faPenSquare} />
                      </button>

                      <button
                        onClick={() => handleApiDelete(entry.id, index)}
                        className="bg-red-600 text-white px-2 py-1 rounded"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* PAGINATION CONTROLS */}
          <div className="flex justify-center mt-4 items-center space-x-2">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded border ${
                currentPage === 1
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-white text-gray-800"
              }`}
            >
              Prev
            </button>

            {(() => {
              const maxVisiblePages = 3;
              const totalPages = Math.ceil(blogs.length / entriesPerPage);
              let startPage = Math.max(
                currentPage - Math.floor(maxVisiblePages / 2),
                1
              );
              let endPage = startPage + maxVisiblePages - 1;

              if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(endPage - maxVisiblePages + 1, 1);
              }

              const pages = [];
              for (let i = startPage; i <= endPage; i++) {
                pages.push(
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    className={`px-3 py-1 rounded border ${
                      currentPage === i
                        ? "bg-gray-800 text-white"
                        : "bg-white text-gray-800"
                    }`}
                  >
                    {i}
                  </button>
                );
              }
              return pages;
            })()}

            <button
              onClick={() =>
                setCurrentPage((prev) =>
                  Math.min(prev + 1, Math.ceil(blogs.length / entriesPerPage))
                )
              }
              disabled={
                currentPage === Math.ceil(blogs.length / entriesPerPage)
              }
              className={`px-3 py-1 rounded border ${
                currentPage === Math.ceil(blogs.length / entriesPerPage)
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-white text-gray-800"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BlogCreate;
